import { Header, Sidebar } from 'components/hoc';
import './style.scss';

export const LayoutComponent = props => {
	return (
		<>
			<section className='layout-wrap'>
				<Header />
				<Sidebar />
				<div className='layout-wrap__container scroll-bar'>{props.children}</div>
			</section>
		</>
	);
};
